// extracted by mini-css-extract-plugin
export default {"calculatorInputForm":"styles_calculatorInputForm__OHSOR","expectedReturnInput":"styles_expectedReturnInput__c4urs"};